import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 py-12 text-white" style={{
    backgroundColor: '#2F2F2F'
  }} data-id="element-32">
      <div className="max-w-6xl mx-auto" data-id="element-33">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-34">
          <div data-id="element-35">
            <div className="flex items-center mb-4" data-id="element-36">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d1fFfebttQrSuGTp9Unqab/Group_45_%283%29.png" alt="Fifth Door" className="h-8 brightness-0 invert" data-id="element-37" />
            </div>
            <p className="text-gray-400 text-sm" data-id="element-38">
              Empowering creators to remix and build amazing games.
            </p>
          </div>
          <div className="text-right flex flex-col justify-between" data-id="element-39">
            <div data-id="element-40">
              <h3 className="text-white font-semibold mb-4" data-id="element-41">Community</h3>
              <a href="https://discord.gg/HCC76Zt82Y" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors duration-300 group" data-id="element-42">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bCTwQuQg1RHyDN81pzL1uF/discord-icon-43736.png" alt="Discord" className="w-5 h-5 transition-all duration-300 group-hover:brightness-0 group-hover:invert" style={{
                filter: 'brightness(0) saturate(100%) invert(71%) sepia(7%) saturate(243%) hue-rotate(169deg) brightness(92%) contrast(87%)'
              }} data-id="element-43" />
                Join our Discord
              </a>
            </div>
            <p className="text-gray-400 text-sm mt-8" data-id="element-44">
              © 2025 Fifth Door. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}